import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

export default function FAQAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-4">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="bg-[#1a1a2e] border border-[#2a2a3e] rounded-2xl overflow-hidden">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left text-white cursor-pointer hover:bg-[#1e1e3f]/60 transition-colors"
            >
              <span className="font-medium text-base">{item.q}</span>
              <span
                className={`w-6 h-6 shrink-0 flex items-center justify-center text-[#a855f7] transition-transform duration-300 ${
                  isOpen ? 'rotate-45' : ''
                }`}
              >
                <i className="ri-add-line text-xl"></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-6 pb-5 text-[#a0a0b0] text-sm leading-relaxed">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}